export const WALLET_ADDRESS = 'wallet_address';
export const USERNAME = 'username';
export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';
export const EXPIRED = 'expired';